<template>
  <div id="all-coach-calendar" class="">
    <div class="">
      <div class="row">
        <div class="col-xs-12 col-md-2 hidden-print">
          <slot name="sidebar"></slot>
          <div class="calendar-filter">
            <div class="form-group">
              <a href="javascript:void(0)" onclick="Beacon('article', '6846098ca0fc382125f8525e', { type: 'modal' })" class="btn btn-default btn-block-xs-only justify-center flex align-items-center gap-x-xs">
                <i class='fa fa-play'></i>Watch Overview Video
              </a>
              <p><small>First time here? Watch the overview video.</small></p>
              <button class="btn btn-primary btn-block" @click="openCreateEventModal">
                <i class="fa fa-plus m-r-xs"></i> Add Availability
              </button>
              <p><small>Tip: Drag on the calendar to quickly create coach availability blocks.</small></p>
            </div>

            <hr v-if="!showCoachIds"/>

            <h4 class="font-semi m-b-sm" v-if="!showCoachIds">Filter Coaches</h4>
            <div v-if="loadingCoaches" class="text-center p-sm">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div v-else-if="!showCoachIds" class="grid grid-cols-1 gap-y-1">
              <div class="form-group m-b-xs">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selectAllCoaches" @change="toggleAllCoaches"> All Coaches
                </label>
              </div>
              <div v-for="coach in coaches" :key="coach.id" class="form-group m-b-xs">
                <label class="checkbox-inline">
                  <input type="checkbox" v-model="selectedCoaches" :value="coach.id" @change="filterCoaches">
                  {{ coach.first_name }} {{ coach.last_name }}
                </label>
              </div>
            </div>

            <hr v-if="!showCoachIds"/>

            <h4 class="font-semi m-b-sm">Calendar Settings</h4>
            <div class="form-group">
              <label>Display Start Time</label>
              <select v-model="slotMinTime" class="form-control" @change="updateCalendarTimes">
                <option v-for="time in timeOptions" :key="time.value" :value="time.value">
                  {{ time.label }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Display End Time</label>
              <select v-model="slotMaxTime" class="form-control" @change="updateCalendarTimes">
                <option v-for="time in timeOptions" :key="time.value" :value="time.value">
                  {{ time.label }}
                </option>
              </select>
            </div>

            <div class="form-group m-t-xs">
              <button class="btn btn-sm btn-default btn-outline" @click="resetTimeRange">
                Reset to Default Times
              </button>
            </div>

            <hr/>

            <div id="calendar-trash" class="text-danger border rounded-sm border-red-200 border-solid p-sm" v-show="dragging">
              <i class="fa fa-trash-o m-r-xs"></i><span>Drag here to delete</span>
            </div>
            <div v-if="error" class="alert alert-danger m-t-sm">
              <small><span class="text-danger">{{ errorMessage }}</span></small>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <div>
            <div v-if="calendarOptionsLoaded">
              <FullCalendar :options="calendarOptions" ref="calendar" />
            </div>
            <div v-else class="text-center p-lg">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Event Modal -->
    <div id="create-availability-modal" class="modal fade hidden-print" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content p-lg">
          <div class="flex gap-sm align-items-center justify-space-between m-b-sm">
            <h2 class="font-heavy m-t-none m-b-none">Create Private Lesson Availability</h2>
            <div class="flex h-12 w-12 align-items-center justify-center rounded-full bg-green-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-green-700">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z" />
              </svg>
            </div>
          </div>
          <form class="m-t-m">
            <div class="form-group">
              <label>Coach</label>
              <select v-model="newEvent.coachId" class="form-control" required>
                <option value="">Select Coach</option>
                <option v-for="coach in coaches" :key="coach.id" :value="coach.id">
                  {{ coach.first_name }} {{ coach.last_name }}
                </option>
              </select>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Date</label>
                  <input type="date" v-model="newEvent.startDate" class="form-control" required>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Start Time</label>
                  <input type="time" v-model="newEvent.startTime" class="form-control" required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>End Time</label>
                  <input type="time" v-model="newEvent.endTime" class="form-control" required>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Lesson Length (minutes)</label>
              <select v-model="newEvent.lessonLength" class="form-control" required>
                <option v-for="length in lessonLengthOptions" :key="length" :value="length">{{ length }} minutes</option>
              </select>
              <p class="text-gray-700 m-t-xs font-sm">
                The length of each private lesson. This will create separate time slots of this duration within your selected time range.
              </p>
              <p class="text-gray-700 m-t-xs font-semi bg-gray-50 p-xs rounded-xs">
                <span v-if="previewLessonCount > 0">Based on your time range and lesson length, {{ previewLessonCount }} available time slots will be created of {{ newEvent.lessonLength }} minutes each.</span>
              </p>
            </div>

            <div class="flex flex-col gap-sm w-fit text-green-50 bg-green-600 -m-x-lg p-x-lg p-y-sm">
              <div class="flex align-items-center w-fit gap-xs">  
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-green-50">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
                </svg>
                <span class="text-heavy text-green-50">WIQ TIP</span>
              </div>
              <span>Create your private lesson schedule for a single date above, then use the repeat option below to extend the schedule out into the future. You can also set the same schedule for multiple days of the week.</span>
            </div>

            <div class="form-group m-t-sm">
              <label>Repeat</label>
              <div>
                <label class="checkbox-inline" v-for="(label, day) in weekdays" :key="day">
                  <input type="checkbox" v-model="newEvent.repeat[day]"> {{ label }}
                </label>
              </div>
            </div>

            <div v-if="isRepeatSelected()" class="form-group m-t-xs">
              <label>Repeat Until</label>
              <input type="date" class="form-control" v-model="newEvent.repeatUntil"
                     :min="newEvent.startDate" required>
            </div>

            <div class="form-group">
              <div class="flex gap-x-xs">
                <label>Roster(s)</label>
                <VDropdown theme="info-tooltip">
                  <i class="fa fa-question"></i>
                  <template v-slot:popper>
                    <div>
                      <p class="header">
                        Why link to specific rosters?
                      </p>
                      <p>
                        With a roster linked, only wrestlers who are on that roster will be able to see the private lesson availability.
                      </p>
                      <p>
                        This helps target specific age groups or skill levels for private lessons.
                      </p>
                    </div>
                  </template>
                </VDropdown>
              </div>
              <div class="-m-t-xs">
                <div class="flex flex-wrap gap-xxs m-b-xs m-t-xs">
                  <button
                    v-for="roster in selectedRosters"
                    :key="roster.id"
                    @click="toggleRoster(roster)"
                    class="btn btn-success btn-outline rounded-lg font-small"
                    style="padding: 2px 6px;">
                    {{ roster.name }}
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <search
                    class="search-form"
                    response-key="rosters"
                    placeholder="Type the name of a roster..."
                    :mutate-history="false"
                    :allow-add="false"
                    only-dismiss-model="Roster"
                    :small-input="true"
                    :display-all-on-empty="false"
                    readable-model-name="roster"
                    base-url="/api/v1/rosters">
                  <template v-slot:list="slotProps">
                    <div
                        class="border-top m-t-sm m-b-xs p-t-sm p-b-xs cursor-pointer flex justify-space-between align-items-center p-r-sm"
                        @click="toggleRoster(slotProps.result)">
                      <div>
                        {{ slotProps.result.name }}
                      </div>
                      <div class="border rounded-sm border-blue-200 border-solid font-small"
                           style="padding: 2px 6px;">
                        Link
                      </div>
                    </div>
                  </template>
                </search>
              </div>
            </div>

            <div class="form-group">
              <label>Location</label>
              <input v-model="newEvent.location" type="text" class="form-control">
            </div>

            <div class="form-group">
              <label>Notes</label>
              <input id="private-lesson-notes" type="hidden" name="content">
              <trix-editor input="private-lesson-notes" class="trix-content"></trix-editor>
            </div>

            <div class="flex flex-col gap-y-sm m-t-m">
              <ladda-button @lbClicked="saveAvailability" el-class="btn-primary w-full" :loading="saving" :disabled="saving">
                Create Availability
              </ladda-button>
              <button type="button" class="btn btn-default w-full" data-dismiss="modal">Cancel</button>
              <div v-show="error">
                <small>
                  <span class="text-danger">{{ errorMessage }}</span>
                </small>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Delete Event Modal -->
    <div id="delete-availability-modal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Delete Availability</h4>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this availability slot?</p>
            <!-- TODO need to handle bookings that are not in an available state (confirmed, in the past which we shouldn't delete, etc)-->
            <div v-if="currentEvent">
              <p><strong>Coach:</strong> {{ getCoachName(currentEvent.resourceId) }}</p>
              <p><strong>Date:</strong> {{ formatDate(currentEvent.start) }}</p>
              <p><strong>Time:</strong> {{ formatTime(currentEvent.start) }} - {{ formatTime(currentEvent.end) }}</p>
            </div>

            <!-- Eventually we may want to have the ability to delete all recurring instances, but we have not added that yet -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="confirmDeleteEvent" :disabled="deleting">
              <span v-if="deleting">Deleting...</span>
              <span v-else>Delete</span>
            </button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorableMix } from './mixins/errorable_mix';
import FullCalendar from '@fullcalendar/vue';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import adaptivePlugin from '@fullcalendar/adaptive';
import Search from '../../shared/search.vue';
import { trixFileAttachmentMix } from './mixins/trix_file_attachment_mix';
import qs from 'qs';
import LaddaButton from '../../shared/ladda_button.vue'

export default {
  name: 'private-lesson-availability-calendar',
  components: {
    FullCalendar,
    Search,
    LaddaButton
  },
  props: {
    showCoachIds: {
      type: Array,
      required: false
    }
  },
  mixins: [errorableMix, trixFileAttachmentMix],
  data() {
    return {
      loadingCoaches: true,
      coaches: [],
      selectedCoaches: [],
      selectAllCoaches: true,
      events: [],
      calendarOptionsLoaded: false,
      dragging: false,
      saving: false,
      deleting: false,
      currentEvent: null,
      deleteAllRecurring: false,
      timeZone: 'local',
      slotMinTime: '06:00:00',
      slotMaxTime: '22:00:00',
      timeOptions: [
        { value: '04:00:00', label: '4:00 AM' },
        { value: '05:00:00', label: '5:00 AM' },
        { value: '06:00:00', label: '6:00 AM' },
        { value: '07:00:00', label: '7:00 AM' },
        { value: '08:00:00', label: '8:00 AM' },
        { value: '09:00:00', label: '9:00 AM' },
        { value: '10:00:00', label: '10:00 AM' },
        { value: '11:00:00', label: '11:00 AM' },
        { value: '12:00:00', label: '12:00 PM' },
        { value: '13:00:00', label: '1:00 PM' },
        { value: '14:00:00', label: '2:00 PM' },
        { value: '15:00:00', label: '3:00 PM' },
        { value: '16:00:00', label: '4:00 PM' },
        { value: '17:00:00', label: '5:00 PM' },
        { value: '18:00:00', label: '6:00 PM' },
        { value: '19:00:00', label: '7:00 PM' },
        { value: '20:00:00', label: '8:00 PM' },
        { value: '21:00:00', label: '9:00 PM' },
        { value: '22:00:00', label: '10:00 PM' },
        { value: '23:00:00', label: '11:00 PM' },
        { value: '23:59:00', label: '11:59 PM' }
      ],

      newEvent: {
        coachId: '',
        startDate: '',
        startTime: '',
        endTime: '',
        lessonLength: 60,
        repeatUntil: '',
        repeat: {
          sun: false,
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false
        }
      },

      weekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },

      lessonLengthOptions: [30, 45, 60, 90, 120],

      selectedRosters: [],
      trixEditor: null,

      calendarOptions: {
        plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGridPlugin, adaptivePlugin],
        schedulerLicenseKey: '0677983463-fcs-1739210166',
        initialView: 'resourceTimelineDay',
        height: 'auto',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        slotMinTime: '06:00:00',
        slotMaxTime: '22:00:00',
        buttonText: {
          today: 'Today',
          month: 'Month',
          week: 'Week',
          day: 'Day',
          list: 'List',
          multiMonthYear: 'Year',
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'resourceTimelineDay,resourceTimelineWeek'
        },
        views: {
          resourceTimelineDay: {
            slotDuration: '00:30:00',
            slotLabelInterval: '01:00:00',
            slotMinWidth: 60,
            titleFormat: { year: 'numeric', month: 'short', day: 'numeric', weekday: 'long' }
          },
          resourceTimelineWeek: {
            slotDuration: '01:00:00',
            slotLabelInterval: '01:00:00',
            slotMinWidth: 100,
            contentHeight: 'auto'
          },
          resourceTimelineMonth: {
            slotDuration: '01:00:00',
            slotMinWidth: 60
          }
        },
        resourceAreaHeaderContent: 'Coaches',
        nowIndicator: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventDrop: this.handleEventChange,
        eventResize: this.handleEventChange,
        eventDragStart: () => { this.dragging = true; },
        eventDragStop: this.handleEventDragStop,
        resourceAreaWidth: '15%',
        datesSet: this.handleDatesSet,
        eventTimeFormat: {
          hour: 'numeric',
          minute: '2-digit',
          meridiem: 'short'
        },

        // Dynamic resources loading
        resources: (fetchInfo, successCallback, failureCallback) => {
          if (this.coaches && this.coaches.length > 0) {
            const resources = this.coaches
              .filter(coach => this.selectedCoaches.includes(coach.id))
              .map(coach => ({
                id: coach.id.toString(),
                title: `${coach.first_name} ${coach.last_name}`
              }));
            successCallback(resources);
          } else {
            this.fetchCoaches()
              .then(() => {
                const resources = this.coaches
                  .filter(coach => this.selectedCoaches.includes(coach.id))
                  .map(coach => ({
                    id: coach.id.toString(),
                    title: `${coach.first_name} ${coach.last_name}`
                  }));
                successCallback(resources);
              })
              .catch(error => {
                console.error('Error fetching coaches:', error);
                failureCallback(error);
              });
          }
        },

        // Dynamic events loading
        eventSources: [
          {
            events: (fetchInfo, successCallback, failureCallback) => {
              const params = {
                event_type: 'private_lesson',
                start: fetchInfo.startStr,
                end: fetchInfo.endStr,
                preventCache: new Date(),
                coach_ids: this.selectedCoaches,
                expand: ['event_bookings', 'private_lessons']
              };
              const url = this.$apiService.eventsUrl('?' + qs.stringify(params, { arrayFormat: 'brackets' }));
              
              axios.get(url, { params })
                .then(response => {
                  // Use the existing formatting logic
                  const formattedEvents = this.formatEvents(response.data.events);
                  successCallback(formattedEvents);
                })
                .catch(error => {
                  console.error('Error fetching events:', error);
                  failureCallback(error);
                });
            }
          }
        ],

        // Custom event rendering to match the mockup
        eventContent: (arg) => {
          const event = arg.event;
          const start = moment(event.start);
          const end = moment(event.end);
          const status = event.extendedProps.coach_booking_status;
          const coachName = event.extendedProps.coach_booking_name;
          const coachInitials = coachName.split(' ').map(name => name[0]).join('');
          const otherBookings = event.extendedProps.other_bookings || [];
          const billingPlan = event.extendedProps.billing_plan;
          const privateLessonData = event.extendedProps.private_lesson;

          // Filter to get only wrestler bookings
          const wrestlerBookings = otherBookings.filter(booking =>
            booking.profile_type === 'WrestlerProfile'
          );

          // Count confirmed wrestler bookings
          const countByStatus = privateLessonData.status === 'completed' ? 'completed' : 'confirmed';
          const confirmedWrestlerCount = wrestlerBookings.filter(booking =>
            booking.status === countByStatus
          ).length;

          // Create HTML for lesson details (price, capacity, etc)
          let billingPlanHtml = '';
          if (billingPlan) {
            billingPlanHtml = `
              <div class="text-12 flex flex-col" style="row-gap: 1px;">
                <div>${billingPlan.name}</div>
                <div>${confirmedWrestlerCount}/${billingPlan.max_wrestler_count} wrestlers</div>
              </div>
            `;
          }

          // Create HTML for wrestlers if any exist
          let wrestlersHtml = '';
          if (wrestlerBookings.length > 0) {
            // Group wrestlers by status
            const confirmedWrestlers = wrestlerBookings.filter(b => b.status === 'confirmed');
            const completedWrestlers = wrestlerBookings.filter(b => b.status === 'completed');
            const invitedWrestlers = wrestlerBookings.filter(b => b.status === 'invited');
            const declinedWrestlers = wrestlerBookings.filter(b => b.status === 'declined');
            const cancelledWrestlers = wrestlerBookings.filter(b => b.status === 'cancelled');

            // Function to format wrestler name
            const formatWrestlerName = (booking) => {
              const wrestlerName = booking.profile ?
                (booking.profile.display_name || 'Unknown') :
                'Unknown';

              let wrestlerDisplayName = 'Unknown';
              if (wrestlerName && wrestlerName !== 'Unknown') {
                const nameParts = wrestlerName.split(' ');
                if (nameParts.length > 1) {
                  // First initial + full last name (e.g., "J. Smith")
                  wrestlerDisplayName = `${nameParts[0][0]}. ${nameParts.slice(1).join(' ')}`;
                } else {
                  wrestlerDisplayName = wrestlerName;
                }
              }

              return `<div class="event-wrestler">${wrestlerDisplayName}</div>`;
            };

            // Function to create a section for a group of wrestlers
            const createWrestlerSection = (wrestlers, status) => {
              if (wrestlers.length === 0) return '';

              // Get status icon and label
              const statusIcon = this.getStatusIcon(status);
              const statusLabel = this.getStatusLabel(status);

              return `
                <div class="wrestler-section">
                  <div class="wrestler-section-header">
                    ${statusIcon} ${statusLabel}
                  </div>
                  <div class="wrestler-section-list">
                    ${wrestlers.map(formatWrestlerName).join('')}
                  </div>
                </div>
              `;
            };

            // Create sections for each status group
            wrestlersHtml = `
              <div class="event-wrestlers">
                ${createWrestlerSection(completedWrestlers, 'completed')}
                ${createWrestlerSection(confirmedWrestlers, 'confirmed')}
                ${createWrestlerSection(invitedWrestlers, 'invited')}
                ${createWrestlerSection(declinedWrestlers, 'declined')}
                ${createWrestlerSection(cancelledWrestlers, 'cancelled')}
              </div>
            `;
          }

          // Get status icon for the coach booking
          const statusIcon = this.getStatusIcon(status);

          return {
            html: `
              <div class="custom-event-content">
                <div class="text-12 upper-label border-solid border-gray-200 border-b w-full" style="margin-top: -4px; margin-bottom: 2px;">
                    ${this.getStatusLabel(status)}
                  </div>
                <div class="event-title" style="margin-top: 2px;">
                  <div class="flex gap-x-xs align-items-center font-semi">
                    ${statusIcon} ${coachInitials}
                  </div>
                </div>
                ${billingPlanHtml}
                ${wrestlersHtml}
              </div>
            `
          };
        }
      },
      calendarApiLoaded: false,
    };
  },
  mounted() {
    this.fetchCoaches();
    this.$nextTick(() => {
      this.setupTrashZone();
    });

    // Load saved time range preferences if available
    this.loadTimeRangePreferences();

    // Set up Trix editor
    document.addEventListener('trix-initialize', this.trixInit);
  },
  beforeDestroy() {
    document.removeEventListener('trix-initialize', this.trixInit);
  },
  computed: {
    previewLessonCount() {
      if (!this.newEvent.startDate || !this.newEvent.startTime || !this.newEvent.endTime) {
        return 0;
      }
      const startDateTime = new Date(`${this.newEvent.startDate}T${this.newEvent.startTime}:00`);
      const endDateTime = new Date(`${this.newEvent.startDate}T${this.newEvent.endTime}:00`);
      const totalMinutes = (endDateTime - startDateTime) / (1000 * 60);
      const lessonLength = parseInt(this.newEvent.lessonLength);

      // Calculate how many slots we can fit
      const slotsCount = Math.floor(totalMinutes / lessonLength);
      return slotsCount;
    }
  },
  methods: {
    fetchCoaches() {
      this.loadingCoaches = true;
      const url = this.$apiService.coachesAcceptingPrivateLessonsUrl();

      return axios.get(url)
        .then(response => {
          if (this.showCoachIds) {
            this.coaches = response.data.coaches.filter(coach => this.showCoachIds.includes(coach.id));
          } else {
            this.coaches = response.data.coaches;
          }
          this.selectedCoaches = this.coaches.map(coach => coach.id);
          this.setupCalendarResources();
          this.loadingCoaches = false;
          return this.coaches; // Return coaches for promise chaining
        })
        .catch(error => {
          this.error = true;
          this.errorMessage = 'Failed to load coaches';
          this.loadingCoaches = false;
          console.error('Error loading coaches:', error);
          throw error; // Rethrow for promise chaining
        });
    },

    setupCalendarResources() {
      // No longer needed since resources are loaded dynamically
      this.calendarOptionsLoaded = true;
    },

    waitForCalendarApi() {
      // Check if the calendar API is available
      const calendar = this.getCalendarApi();
      if (calendar) {
        this.calendarApiLoaded = true;
        // Initialize the calendar with events
        this.fetchEvents();
      } else {
        // Retry after a short delay
        setTimeout(() => {
          this.waitForCalendarApi();
        }, 500);
      }
    },

    fetchEvents() {
      const calendar = this.getCalendarApi();
      if (calendar) {
        calendar.refetchEvents();
      } else {
        console.error('Calendar API not available for refetching events');
      }
    },

    formatEvents(events) {
      const formattedEvents = [];

      events.forEach(event => {
        // Check if this is a private lesson event
        if (event.event_type === 'private_lesson') {
          // Try both methods of getting coach information
          const coachBookings = event.event_bookings.filter(booking =>
            booking.profile_type === 'CoachProfile' &&
            this.selectedCoaches.includes(booking.profile_id)
          );

          // Get all other bookings (wrestlers) with their profiles
          const otherBookings = event.event_bookings.filter(booking =>
            booking.id !== (coachBookings[0] ? coachBookings[0].id : null)
          );

          // Get private lesson data if available
          let privateLessonData = null;
          if (event.private_lessons && event.private_lessons.length > 0) {
            privateLessonData = event.private_lessons[0];
          }

          // Get the billing plan from the booking
          // for now we just pull a billing plan from the first booking
          // but in the future we may need to pull from all bookings if prices areerdfference
          let billingPlan = null;
          if (otherBookings.length > 0) {
            billingPlan = otherBookings[0].billing_plan;
          }

          // Create an event for each coach booking
          coachBookings.forEach(booking => {
            formattedEvents.push({
              id: event.id,
              resourceId: booking.profile_id.toString(),
              title: this.getEventTitle(event, booking),
              start: event.start_at,
              end: event.end_at,
              allDay: event.all_day,
              backgroundColor: this.getStatusColor(booking.status),
              borderColor: this.getStatusColor(booking.status),
              textColor: '#FFFFFF',
              recurring: event.has_repeated_events || event.parent_id != null,
              event_type: event.event_type,
              coach_booking_id: booking.id,
              coach_booking_status: booking.status,
              coach_booking_name: booking.profile.display_name,
              other_bookings: otherBookings,
              billing_plan: billingPlan,
              private_lesson: privateLessonData
            });
          });
        }
      });

      return formattedEvents;
    },

    getEventTitle(event, booking) {
      // For better styling, we're returning a simplified title
      // The full formatting will be handled via eventContent
      return this.getStatusLabel(booking.status);
    },

    getStatusIcon(status) {
      return status === 'confirmed' ?
            '<i class="fa fa-check-circle text-blue-200"></i>' :
            status === 'cancelled' ?
            '<i class="fa fa-ban text-red-50"></i>' :
            status === 'invited' ?
            '<i class="fa fa-envelope-o text-amber-200"></i>' :
            status === 'declined' ?
            '<i class="fa fa-times-circle text-red-400"></i>' :
            status === 'completed' ?
            '<i class="fa fa-check text-green-200"></i>' :
            '<i class="fa fa-clock-o text-gray-300"></i>';
    },

    getStatusLabel(status) {
      switch(status) {
        case 'pending': return 'Open';
        case 'confirmed': return 'Confirmed';
        case 'cancelled': return 'Cancelled';
        case 'completed': return 'Completed';
        case 'invited': return 'Invited';
        case 'declined': return 'Declined';
        default: return 'Open';
      }
    },

    getStatusColor(status) {
      switch(status) {
        case 'pending': return '#324D67'; // Gray for available slots
        case 'confirmed': return '#2680C0'; // Blue for confirmed
        case 'cancelled': return '#D64343'; // Red
        case 'completed': return '#27AA83'; // Green for completed
        case 'invited': return '#E9B949'; // Amber/Orange for invited
        case 'declined': return '#FACCCC'; // Darker gray for declined
        default: return '#48647F'; // Default gray
      }
    },

    getCalendarApi() {
      return this.$refs.calendar ? this.$refs.calendar.getApi() : null;
    },

    toggleAllCoaches() {
      if (this.selectAllCoaches) {
        this.selectedCoaches = this.coaches.map(coach => coach.id);
      } else {
        this.selectedCoaches = [];
      }
      this.filterCoaches();
    },

    filterCoaches() {
      // Update selectAllCoaches state
      this.selectAllCoaches = this.selectedCoaches.length === this.coaches.length;

      // Refetch events for selected coaches
      this.fetchEvents();

      // Refetch resources for selected coaches
      const calendar = this.getCalendarApi();
      if (calendar && typeof calendar.refetchResources === 'function') {
        calendar.refetchResources();
      }
    },

    openCreateEventModal() {
      // Get default end date (30 days from now)
      const defaultEndDate = new Date();
      defaultEndDate.setDate(defaultEndDate.getDate() + 30);

      // This applies only to coach dashboard pages or teams with only 1 coach
      const coachId = this.coaches.length === 1 ? this.coaches[0].id : '';
      
      // Reset form
      this.newEvent = {
        coachId: coachId,
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0],
        startTime: '16:00',
        endTime: '17:00',
        lessonLength: 60,
        repeatUntil: '',
        repeat: {
          sun: false,
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false
        }
      };

      // Clear previously selected rosters
      this.selectedRosters = [];

      // Clear Trix editor content
      this.$nextTick(() => {
        if (this.trixEditor) {
          this.trixEditor.loadHTML('');
        }
      });

      $('#create-availability-modal').modal('show');
    },
    handleDateSelect(selectInfo) {
      const resourceId = selectInfo.resource ? selectInfo.resource.id : '';

      // Find coach based on resourceId
      const coach = this.coaches.find(c => c.id.toString() === resourceId);

      if (coach) {
        // Format dates and times for the form
        const startDate = selectInfo.start;
        const endDate = selectInfo.end;

        this.newEvent = {
          coachId: coach.id,
          startDate: this.formatDateInput(startDate),
          endDate: this.formatDateInput(startDate), // Same day initially
          startTime: this.formatTimeInput(startDate),
          endTime: this.formatTimeInput(endDate),
          lessonLength: 60,
          location: '',
          repeatUntil: '',
          repeat: {
            sun: false,
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false
          }
        };

        // Clear previously selected rosters
        this.selectedRosters = [];

        // Clear Trix editor content
        this.$nextTick(() => {
          if (this.trixEditor) {
            this.trixEditor.loadHTML('');
          }
        });

        $('#create-availability-modal').modal('show');
      }

      // Clear the selection
      const calendarApi = selectInfo.view.calendar;
      calendarApi.unselect();
    },

    formatTimeInput(date) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    formatDateInput(date) {
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    saveAvailability() {
      // Validate repeat until date if repeating
      if (this.isRepeatSelected() && !this.newEvent.repeatUntil) {
        this.errorMessage = "Please select a date for 'Repeat Until'";
        this.error = true;
        this.saving = false;
        return;
      }

      if (this.newEvent.coachId === '') {
        this.errorMessage = "Please select a coach";
        this.error = true;
        this.saving = false;
        return;
      }

      this.error = false;
      this.errorMessage = '';
      this.saving = true;

      // Get start and end times as Date objects
      // todo test on the thirty and 45 minute markers
      const startDateTime = new Date(`${this.newEvent.startDate}T${this.newEvent.startTime}:00`);
      const endDateTime = new Date(`${this.newEvent.startDate}T${this.newEvent.endTime}:00`);
      const totalMinutes = (endDateTime - startDateTime) / (1000 * 60);
      const lessonLength = parseInt(this.newEvent.lessonLength);

      // Calculate how many slots we can fit
      const slotsCount = Math.floor(totalMinutes / lessonLength);
      const events = [];

      // Create individual slots
      for (let i = 0; i < slotsCount; i++) {
        const slotStart = new Date(startDateTime);
        slotStart.setMinutes(slotStart.getMinutes() + (i * lessonLength));

        const slotEnd = new Date(slotStart);
        slotEnd.setMinutes(slotEnd.getMinutes() + lessonLength);

        const event = {
          event_type: 'private_lesson',
          start_at: slotStart.toISOString(),
          end_at: slotEnd.toISOString(),
          name: `Private Lesson - ${this.getCoachName(this.newEvent.coachId)}`,
          color: '#27AA83',
          all_day: false,
          location: this.newEvent.location,
          notes: document.getElementById('private-lesson-notes').value,
          event_bookings_attributes: [
            {
              profile_id: this.newEvent.coachId,
              profile_type: 'CoachProfile',
              status: 'pending',
              private_lesson_attributes: {
                status: 'available'
              }
            }
          ],
          roster_events_attributes: this.selectedRosters.map(roster => ({
            roster_id: roster.id
          }))
        };

        // Add repeat information if any days are selected
        const hasRepeat = this.isRepeatSelected();
        if (hasRepeat) {
          // Convert repeatUntil to end of day in user's timezone
          // This matches the logic in event_create.vue but without moment.js
          const repeatUntilDate = new Date(this.newEvent.repeatUntil);
          // Set to end of day (23:59:59.999)
          repeatUntilDate.setHours(23, 59, 59, 999);

          // Format in the structure expected by the API
          event.repeat = {
            until: repeatUntilDate.toISOString(),
            sun: this.newEvent.repeat.sun,
            mon: this.newEvent.repeat.mon,
            tue: this.newEvent.repeat.tue,
            wed: this.newEvent.repeat.wed,
            thu: this.newEvent.repeat.thu,
            fri: this.newEvent.repeat.fri,
            sat: this.newEvent.repeat.sat
          };
        }

        events.push(event);
      }

      // Create a counter for tracking completed requests
      let completedCount = 0;
      let hasError = false;

      // Create each event
      events.forEach(event => {
        const url = this.$apiService.eventsUrl('');
        axios.post(url, { event })
          .then(response => {
            completedCount++;

            if (completedCount === events.length) {
              if (!hasError) {
                $('#create-availability-modal').modal('hide');
                this.$notificationManager.$emit('show-toast', 'Availability slots created successfully', true);
                this.fetchEvents();
              }
              this.saving = false;
            }
          })
          .catch(error => {
            hasError = true;
            completedCount++;
            this.errorMessage = this.parseErrorResponse(error);
            this.error = true;

            if (completedCount === events.length) {
              this.saving = false;
            }
          });
      });

      // If no slots could be created, show an error
      if (events.length === 0) {
        this.errorMessage = "No slots could be created. Please ensure the time range is long enough for the lesson length.";
        this.error = true;
        this.saving = false;
      }
    },

    isRepeatSelected() {
      return Object.values(this.newEvent.repeat).some(val => val);
    },

    handleEventClick(info) {
      const event = this.eventWithPromotedExtendedProps(info.event);
      // Redirect to event show page
      window.location.href = `/events/${event.id}`;
    },

    eventWithPromotedExtendedProps(event) {
      if (!event.extendedProps) {
        return event;
      }

      return {
        id: event.id,
        title: event.title,
        start: event.start,
        end: event.end,
        resourceId: event.getResources()[0].id,
        allDay: event.allDay,
        ...event.extendedProps
      };
    },

    confirmDeleteEvent() {
      if (!this.currentEvent) return;

      this.deleting = true;
      const url = this.$apiService.eventUrl(this.currentEvent.id);

      axios.delete(url)
        .then(() => {
          $('#delete-availability-modal').modal('hide');
          this.$notificationManager.$emit('show-toast', 'Availability deleted', true);
          this.fetchEvents();
        })
        .catch(error => {
          this.errorMessage = this.parseErrorResponse(error);
          this.error = true;
        })
        .finally(() => {
          this.deleting = false;
          this.currentEvent = null;
        });
    },
    handleEventChange(info) {
      const event = this.eventWithPromotedExtendedProps(info.event);
      const resourceId = info.event.getResources()[0].id;

      // Only allow modifying pending (available) bookings
      if (event.bookingStatus && event.bookingStatus !== 'pending') {
        this.$notificationManager.$emit('show-toast',
          `Cannot modify ${this.getStatusLabel(event.bookingStatus).toLowerCase()} private lessons.`,
          false);
        info.revert();
        return;
      }

      if (!this.isEventInFuture(info.event)) {
        info.revert();
        return;
      }

      // Build params object
      const params = {
        event: {
          start_at: event.start.toISOString(),
          end_at: event.end.toISOString(),
          all_day: event.allDay,
          event_bookings_attributes: [],
          update_recurring: false
        }
      };


      // TODO recurring event handling. There are edge cases here that we need to handle, like
      // are recurring events 'series' or are they actually linked? We are basically using recurring events
      // to quicly drag out availability slots, but that does not necessarily mean we should update all future instances
      // if (event.recurring) {
      //   if (confirm('This is a recurring event. Do you want to update all future occurrences?')) {
      //     params.event.update_recurring = true;
      //   }
      // }

      const url = this.$apiService.eventUrl(event.id);
      axios.put(url, params)
        .then(() => {
          this.$notificationManager.$emit('show-toast', 'Availability updated successfully', true);
          this.fetchEvents();
        })
        .catch(error => {
          this.errorMessage = this.parseErrorResponse(error);
          this.error = true;
          info.revert();
        });
    },

    isEventInFuture(event) {
      const eventEnd = new Date(event.end);
      const now = new Date();
      if (eventEnd < now) {
        this.$notificationManager.$emit('show-toast', 'Cannot change past events', false);
        return false;
      }

      return true;
    },
    setupTrashZone() {
      // Position the trash zone at the bottom right of the calendar
      const calendarEl = this.$refs.calendar ? this.$refs.calendar.$el : null;
      if (!calendarEl) return;

      const trashEl = document.getElementById('calendar-trash');
      if (!trashEl) return;

      const calendarRect = calendarEl.getBoundingClientRect();
      trashEl.style.bottom = '20px';
      trashEl.style.right = '20px';
    },

    handleEventDragStop(info) {
      this.dragging = false;

      // Check if dropped on trash zone
      const trashEl = document.getElementById('calendar-trash');
      if (!trashEl) return;

      const trashRect = trashEl.getBoundingClientRect();
      const eventRect = info.jsEvent;

      if (
        eventRect.clientX >= trashRect.left &&
        eventRect.clientX <= trashRect.right &&
        eventRect.clientY >= trashRect.top &&
        eventRect.clientY <= trashRect.bottom
      ) {

        // Make sure we can actually delete this event
        if (this.isEventInFuture(info.event)) {
          // Set current event and open delete modal
          this.currentEvent = this.eventWithPromotedExtendedProps(info.event);
          this.deleteAllRecurring = false;
          $('#delete-availability-modal').modal('show');
        }
      }
    },

    formatDate(date) {
      return format(new Date(date), 'EEEE, MMMM d, yyyy');
    },

    formatTime(date) {
      return format(new Date(date), 'h:mm a');
    },

    getCoachName(resourceId) {
      const coach = this.coaches.find(c => c.id.toString() === resourceId);
      return coach ? `${coach.first_name} ${coach.last_name}` : 'Unknown Coach';
    },

    updateCalendarTimes() {
      const calendar = this.getCalendarApi();
      if (!calendar) return;

      // Validate that min time is before max time
      const minHour = parseInt(this.slotMinTime.split(':')[0]);
      const maxHour = parseInt(this.slotMaxTime.split(':')[0]);

      if (minHour >= maxHour) {
        this.$notificationManager.$emit('show-toast', 'Start time must be earlier than end time', false);
        // Reset to previous valid values
        this.loadTimeRangePreferences();
        return;
      }

      // Update calendar options
      calendar.setOption('slotMinTime', this.slotMinTime);
      calendar.setOption('slotMaxTime', this.slotMaxTime);

      // Save preferences
      this.saveTimeRangePreferences();
    },

    resetTimeRange() {
      this.slotMinTime = '06:00:00';
      this.slotMaxTime = '22:00:00';
      this.updateCalendarTimes();
    },

    saveTimeRangePreferences() {
      try {
        localStorage.setItem('calendar_slot_min_time', this.slotMinTime);
        localStorage.setItem('calendar_slot_max_time', this.slotMaxTime);
      } catch (e) {
        console.error('Failed to save time range preferences', e);
      }
    },

    loadTimeRangePreferences() {
      try {
        const minTime = localStorage.getItem('calendar_slot_min_time');
        const maxTime = localStorage.getItem('calendar_slot_max_time');

        if (minTime) this.slotMinTime = minTime;
        if (maxTime) this.slotMaxTime = maxTime;

        // Update initial calendar options
        this.calendarOptions = {
          ...this.calendarOptions,
          slotMinTime: this.slotMinTime,
          slotMaxTime: this.slotMaxTime
        };
      } catch (e) {
        console.error('Failed to load time range preferences', e);
      }
    },

    toggleRoster(roster) {
      // Clear search
      this.$notificationManager.$emit('profile-clicked', 'Roster');

      // Check if roster is already selected
      const index = this.selectedRosters.findIndex(r => r.id === roster.id);

      if (index !== -1) {
        // Remove from selected rosters
        this.selectedRosters.splice(index, 1);
      } else {
        // Add to selected rosters
        this.selectedRosters.push(roster);
      }
    },

    trixInit(event) {
      const { editor } = event.target;
      this.trixEditor = editor;
    },

    handleDatesSet(dateInfo) {
      /*
      // Store the current date range for possible use in other methods
      this.currentStartDate = dateInfo.startStr;
      this.currentEndDate = dateInfo.endStr;

      // Save the current time range for next time
      this.saveTimeRangePreferences();

      // No need to manually fetch events, FullCalendar will handle this*/

      // todo, for back button hash stuff like in other calendar views
    },
  }
};
</script>

<style>
#all-coach-calendar .fc-resource-timeline .fc-resource-cell {
  font-weight: bold;
  vertical-align: middle;
}

#all-coach-calendar .fc-event {
  cursor: pointer;
  min-height: 24px;
  margin: 2px 0;
  border-radius: 8px !important;
  overflow: hidden;
}

#all-coach-calendar .custom-event-content {
  padding: 6px 10px;
  height: 100%;
  width: 100%;
}

#all-coach-calendar .event-capacity {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
  font-weight: 600;
}

#all-coach-calendar .available-slots {
  color: rgba(191, 255, 234, 0.9);
}

#all-coach-calendar .full-slots {
  color: rgba(255, 191, 191, 0.9);
}

#all-coach-calendar .event-wrestlers {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  padding-top: 2px;
}

#all-coach-calendar .wrestler-section {
  margin-top: 4px;
}

#all-coach-calendar .wrestler-section:first-child {
  margin-top: 0;
}

#all-coach-calendar .wrestler-section-header {
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 1px;
  margin-bottom: 2px;
}

#all-coach-calendar .wrestler-section-header i {
  font-size: 10px;
}

#all-coach-calendar .wrestler-section-list {
  padding-left: 2px;
}

#all-coach-calendar .event-wrestler {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#all-coach-calendar .event-wrestler i {
  font-size: 10px;
  min-width: 10px;
}

#all-coach-calendar .event-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
}

#all-coach-calendar .event-time {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
}

#all-coach-calendar .wrestler-status {
  font-weight: bold;
  margin-left: 3px;
}

#all-coach-calendar .wrestler-status.confirmed {
  color: #bfdaff;
}

#all-coach-calendar .wrestler-status.cancelled {
  color: #ffbfbf;
}

#all-coach-calendar .wrestler-status.pending, #all-coach-calendar .wrestler-status.invited {
  color: #fffdbf;
}

#all-coach-calendar .wrestler-status.declined {
  color: #e0e0e0;
}

#all-coach-calendar .wrestler-status.completed {
  color: #c3ffea;
}

#all-coach-calendar .fc-timeline-slot {
  min-width: 60px !important;
}

#all-coach-calendar .fc-resource-area {
  width: 150px !important;
}

#all-coach-calendar #calendar-trash {
  padding: 10px 15px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

#all-coach-calendar .fc-timeline-slot-cushion {
  padding: 4px !important;
}

#all-coach-calendar .fc .fc-timegrid-slot {
  height: 2.5em;
}

#all-coach-calendar .fc-timegrid-event-harness {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* Add minimum height to the resource timeline view */
#all-coach-calendar .fc-resource-timeline .fc-datagrid-cell-cushion {
  padding: 4px;
}
</style>
